import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import StatusHandler from "Helpers/StatusHandler";
import * as R from "ramda";
import { useDispatch } from "react-redux";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import NotificationsService from "Services/http/endpoints/notifications/NotificationsService";
import moment from "moment-jalaali";
import DatePickerComponent from "Components/DatePickerComponent/DatePickerComponent";
import MuiUpload from "Components/MuiUpload/MuiUpload";
import { GETSAAGAINNOTIFICATION } from "Stores/actionTypes";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import ProjectService from "Services/http/endpoints/project/ProjectService";

export default function AddNotice({ disabled }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [controls, setControls] = useSetState({
    post_type: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      display: true,
    },
    groups: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      display: false,
    },
    users: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      display: false,
    },
    group_notice: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      display: true,
    },
    title: {
      type: "text",
      value: "'",
      validation: {
        required: true,
      },
      display: true,
      multiline: false,
    },
    sati_ExpireJalali: {
      type: "date",
      value: "",
      validation: null,
      display: true,
    },
    describe: {
      type: "text",
      value: 0,
      validation: null,
      display: true,
      multiline: true,
    },
  });

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = async () => {
    setLoading(true);
    setSelectedFile(null);
    setControls({ title: { value: "" } });
    setControls({ describe: { value: "" } });
    setControls({ groups: { display: false } });
    setControls({ users: { display: false } });
    setFormValid({
      title: false,
      post_type: false,
      group_notice: false,
    });
    setControls({ sati_ExpireJalali: { value: moment().endOf("jMonth") } });
    await getPostTypes();
    await getGroups();
    await getGroupNotice();
    setLoading(false);
  };

  const getPostTypes = async () => {
    try {
      const response = await NotificationsService.getPostTypes({
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        const selectItems = response.data.Value.map((items) => {
          return {
            label: items.Name,
            value: items.Id,
          };
        });
        setControls({
          post_type: {
            selectItems: selectItems,
            value: selectItems[0],
          },
        });
        setFormValid((prev) => ({ ...prev, post_type: true }));
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  const getGroups = async () => {
    try {
      const response = await AccountService.getAccountsAllGroup({
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        const selectItems = response.data.Value.filter((i) => i.Id !== 0).map(
          (items) => {
            return {
              label: items.Name,
              value: items.Id,
            };
          }
        );
        setControls({
          groups: {
            selectItems: selectItems,
            value: selectItems[0],
          },
        });
        setFormValid((prev) => ({ ...prev, groups: true }));
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  const getGroupUsers = async (group_id) => {
    setLoading(true);
    try {
      const response = await AccountService.getAllUserGroup({
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        GroupId: group_id,
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        const selectItems = response.data.Value.map((items) => {
          return {
            label: items.Name,
            value: items.Id,
          };
        });
        setControls({
          users: {
            selectItems: selectItems,
            value: selectItems[0],
          },
        });
        setFormValid((prev) => ({ ...prev, users: true }));
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  const getGroupNotice = async () => {
    try {
      const response = await NotificationsService.getGroupNotice({
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        const selectItems = response.data.Value.map((items) => {
          return {
            label: items.Name,
            value: items.Id,
          };
        });
        setControls({
          group_notice: {
            selectItems: selectItems,
            value: selectItems[0],
          },
        });
        setFormValid((prev) => ({ ...prev, group_notice: true }));
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDateChange = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
    if (controlName === "post_type" && value.value === 3) {
      setControls({ groups: { display: true } });
      setControls({ users: { display: false } });
    } else if (controlName === "post_type" && value.value === 4) {
      setControls({ groups: { display: true } });
      setControls({ users: { display: true } });
      await getGroupUsers(controls.groups?.value?.value || 0);
    } else if (
      controlName === "post_type" &&
      (value.value === 1 || value.value === 2)
    ) {
      setControls({ groups: { display: false } });
      setControls({ users: { display: false } });
    }
    if (controlName === "groups") {
      await getGroupUsers(value.value);
    }
  };

  const onChangeFile = ({ target }) => {
    setSelectedFile(target.files[0]);
  };

  const onDeleteFile = () => {
    setSelectedFile(null);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { post_type, group_notice, title, sati_ExpireJalali, describe } =
        controls;
      if (selectedFile) {
        if (
          !R.isEmpty(formValid) &&
          Object.values(formValid).every((item) => item === true)
        ) {
          let fromData = new FormData();
          const timeStamp = new Date(sati_ExpireJalali.value).valueOf();
          fromData.append("KeyGroup", read("groupAKey"));
          fromData.append("KeyUser", read("userAKey"));
          fromData.append("Title", title.value);
          fromData.append("PostTypeId", post_type.value.value);
          fromData.append("GroupNoticeId", group_notice.value.value);
          fromData.append("DateExpire", timeStamp);
          fromData.append("Attachment", selectedFile);
          fromData.append(
            "Value",
            post_type.value.value === 3
              ? controls.groups.value.value
              : post_type.value.value === 4
              ? controls.users.value.value
              : 0
          );
          fromData.append("Descript", describe.value);
          const response = await NotificationsService.postNotice(fromData);
          let err = StatusHandler(response);
          if (!err.isFail) {
            showNotify({
              text: t("mission_accomplished"),
              customClass: "success",
            });
          }
          dispatch({
            type: GETSAAGAINNOTIFICATION,
            status: true,
          });
          onExit();
        } else {
          setCheckValid(true);
          setLoading(false);
        }
      } else {
        setLoading(false);
        showNotify({
          text: t("notSelectedFile"),
          customClass: "warning",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
      setLoading(false);
    }
  };

  const onExit = () => {
    setShowDialog(false);
    setLoading(false);
    setCheckValid(false);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiButton
        color="primary"
        title={<Translator id="notice_add" />}
        innerIcon={<Icons.PlusLg />}
        onClick={onShowDialog}
        hidden={!read("Notice").accessRegister}
        disabled={!read("Notice").accessRegister || disabled}
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="md"
      >
        <BackDropLoading loading={loading} />
        <div className="dialogHeader">
          <p>{<Translator id={"notice_add"} />}</p>
        </div>
        <DialogContent>
          <Grid container spacing={2}>
            {Object.keys(controls).map((key) => {
              return (
                <Grid item sm={key === "describe" ? 12 : 4} xs={12} key={key}>
                  {controls[key].type === "select" && controls[key].display && (
                    <MuiAutoComplete
                      autoSelect={true}
                      options={controls[key].selectItems}
                      label={<Translator id={key} />}
                      value={controls[key].value}
                      onChange={autoCompleteHandler}
                      id={key}
                      helperText={checkValid && !formValid[key]}
                      disabled={!controls[key].display}
                    />
                  )}
                  {(controls[key].type === "text" ||
                    controls[key].type === "number") && (
                    <Input
                      setValue={setValue.bind(this)}
                      value={controls[key].value}
                      name={key}
                      validation={controls[key].validation}
                      label={<Translator id={key} />}
                      placeholder={t(key)}
                      type={controls[key].type}
                      checkValid={checkValid}
                      multiline={controls[key].multiline}
                    />
                  )}
                  {controls[key].type === "date" && (
                    <DatePickerComponent
                      label={t(key)}
                      name={key}
                      value={controls[key].value}
                      onChange={(e) => handleDateChange(key, e)}
                    />
                  )}
                </Grid>
              );
            })}
            <Grid item xs={12} className="mt-2">
              <MuiUpload
                onChange={onChangeFile}
                selectedFile={selectedFile}
                onDeleteFile={onDeleteFile}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            title={<Translator id="button_save" />}
            onClick={onFinish}
          />
          <MuiButton
            onClick={() => setShowDialog(false)}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
